import {
  LOAD_LISTVEHICLE_HONEYTOASTSTREAM,
  LOAD_VEHICLE_HONEYTOASTSTREAM,
} from './actions'

const initialState = {
  vehicleLists: [],
  vehicleListHoneytoast: [],
  videoLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_LISTVEHICLE_HONEYTOASTSTREAM.REQUEST:
      const { loading, cb } = action.payload
      return {
        ...state,
        cb,
        videoLoading: loading,
      }
    case LOAD_LISTVEHICLE_HONEYTOASTSTREAM.SUCCESS:
      return {
        ...state,
        vehicleListHoneytoast: action.payload.data.data,
        videoLoading: false,
      }
    case LOAD_VEHICLE_HONEYTOASTSTREAM.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
      }
    default:
      return state
  }
}
